import { connect } from 'react-redux'
import SettingsPage from './settings-page'
import { config } from '../../../redux/selectors'
import { withRouter } from 'react-router-dom'

const mapState = (state, ownProps) => {
  return {
    config: config(state),
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default withRouter(connect(mapState, mapDispatch)(SettingsPage))



// WEBPACK FOOTER //
// ./src/components/views/settings-page/settings-page.connect.js